export default function(target) {
	const $floatingBox = $('.js-floating');

	$(window).on('scroll', function() {
		const scrollPosition = $(window).height() + $(window).scrollTop();
		const targetOffset = $(target).offset().top;
		const floatingBoxHeight = $floatingBox.outerHeight();

		if(scrollPosition >= targetOffset) {
			$floatingBox.css({
				position: "absolute",
				top: (targetOffset + 100) - (floatingBoxHeight + 100),
				bottom: "initial"
			});
		} else {
			$floatingBox.css({
				position: "fixed",
				top: "initial",
				bottom: 0,
			});
		}

		if(window.innerWidth < 768) {
			if(scrollPosition >= targetOffset) {
				$floatingBox.css({
					position: "absolute",
					top: targetOffset - floatingBoxHeight,
					bottom: "initial"
				});
			} else {
				$floatingBox.css({
					position: "fixed",
					top: "initial",
					bottom: 0
				});
			}
		}
	});
}
